<mat-dialog-content class="no-scrollbar download-dialog-content p-0">
  <div
    class="download-dialog-shell custom-row flex-no-wrap row-gap-0 p-0 position-relative overflow-hidden column-gap-0"
  >
    <app-prudent-button
      title="Close dialog"
      titleClassOverrides="visually-hidden"
      class="close-icon download-dialog-close-icon position-absolute"
      classOverrides="p-0 border-none border-radius-round"
      buttonType="primary-blue"
      buttonSize="small"
      glyph="x-close"
      [inline]="true"
      (click)="close()"
    />

    <div class="download-dialog-art position-relative bg-neutral-100 overflow-hidden">
      <img class="w-100 h-100" src="assets/images/prudent-plus-app.svg" alt="Prudent Plus mobile app preview" />
      <div class="download-dialog-art-overlay"></div>
    </div>

    <div class="download-dialog-main custom-column align-items-center row-gap-0 position-relative overflow-hidden">
      <p class="download-dialog-title text-center m-0 f-36 fw-extra-heavy white-space-nowrap">
        <span class="download-dialog-prudent-plus fc-white">Prudent Plus</span>
        <span class="download-dialog-on-the-go fc-white"> On the go</span>
      </p>
      <div class="download-dialog-qr d-flex justify-content-center align-items-center mt-x-large">
        <div
          class="download-dialog-qr-wrapper p-xx-small position-relative bg-primary-25 d-flex align-items-center justify-content-center"
        >
          <span class="download-dialog-qr-corner position-absolute top-left" aria-hidden="true"></span>
          <span class="download-dialog-qr-corner position-absolute top-right" aria-hidden="true"></span>
          <span class="download-dialog-qr-corner position-absolute bottom-right" aria-hidden="true"></span>
          <span class="download-dialog-qr-corner position-absolute bottom-left" aria-hidden="true"></span>
          <img class="w-100 h-100" src="assets/glyphs/new-design/download-app/unified_qr.svg" alt="Unified QR code" />
        </div>
      </div>
      <p class="download-dialog-caption text-center m-0 lh-14 fc-white f-12 fw-light mt-small"
        >Scan to download the App</p
      >
      <p class="download-dialog-description text-center m-0 lh-20 fc-white f-16 fw-lightmt-x-large">
        Trusted by 3M+ users to manage their insurance and wellness benefits
        <br />
        &mdash; free on iOS &amp; Android.
      </p>
    </div>
  </div>
</mat-dialog-content>
